/***
 * 私有指令实体组件
 * zxw
 * 2024-04-07
 */

import { useState, useEffect } from 'react';
import { ConfigProvider, Modal, Row, Col, message, Input } from 'antd';
import $ from 'jquery';
import { winWidth, AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '指令';

const { TextArea } = Input;

const CommandPrivateEntry = (props) => {
    const [_props, setProps] = useState(props);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');

    useEffect(() => {
        setProps(props);
        //  修改时，初始化指令标题和指令内容
        if (props.record) {
            setTitle(props.record.title);
            setContent(props.record.content)
        }
    }, [props]);

    const cancel = () => {
        setProps(false);
        setLoading(false);
        setTitle('');
        setContent('');
    };
    const ok = () => {
        //  校验参数
        if (!title) {
            message.error('指令标题不能为空！');
            return;
        }
        if (!content) {
            message.error('指令内容不能为空！');
            return;
        }
        setLoading(true);
        if (_props.record) {
            //  修改
            update();
        } else {
            //  新增
            create();
        }
    }

    const create = () => {
        $.ajax({
            url: `${CNF.api}command/privates`,
            headers: AddRequestHeaders(),
            type: 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                'title': title,
                'content': content,
            }), success: function (data) {
                if (data.res === 0) {
                    message.success(data.msg, CNF.messageDuration);
                    setTimeout(() => {
                        cancel();
                        props.setIsRefresh(true);
                    }, CNF.messageDuration * 1000);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                    setLoading(false);
                }
            }
        });
    }

    const update = () => {
        $.ajax({
            url: `${CNF.api}command/privates/${_props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                'action': 'UPDATE',
                'title': title,
                'content': content,
            }), success: function (data) {
                if (data.res === 0) {
                    message.success(data.msg, CNF.messageDuration);
                    setTimeout(() => {
                        cancel();
                        props.setIsRefresh(true);
                    }, CNF.messageDuration * 1000);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                    setLoading(false);
                }
            }
        });
    }

    return <ConfigProvider
        theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}
    >
        <Modal
            width={winWidth / 3}
            title={(_props.record ? '修改' : '创建') + MODULENAME}
            open={_props.isModalOpen}
            onOk={ok}
            onCancel={cancel}
            keyboard={true}
            okText='确认'
            cancelText='取消'
            okButtonProps={{ disabled: loading }}
        >
            <Row style={{ marginTop: CNF.rowMarginTop, lineHeight: 2.2 }}>
                <Col span={24}><span style={{ fontSize: 15 }}>指令标题<span style={{ color: '#FF0000' }} >*</span></span></Col>
                <Col span={24}>
                    <Input
                        placeholder='请输入指令标题'
                        onChange={(e) => { setTitle(e.target.value) }}
                        value={title}
                        disabled={loading}
                    />
                </Col>
            </Row>
            <Row style={{ marginTop: CNF.rowMarginTop }}>
                <Col span={24}><span style={{ fontSize: 15 }}>指令内容<span style={{ color: '#FF0000' }} >*</span></span></Col>
                <Col span={24}>
                    <TextArea
                        placeholder='请输入指令内容'
                        rows={10}
                        autoSize={{ minRows: 12, maxRows: 12 }}
                        onChange={(e) => { setContent(e.target.value) }}
                        value={content}
                        disabled={loading}
                    />
                </Col>
            </Row>
        </Modal>
    </ConfigProvider>
}

export default CommandPrivateEntry;